/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import { CustomToastContent } from "../../../examples/CustomToastContent/index";

// Dashboard standardized components

// Functions from store
import {
  createDynamicColumn,
  createItem,
  editItemMaster,
  getDownloadItemMasterWithPagination,
  getDynamicColumn,
  getItemMasterWithPagination,
  getItemTypes,
  getSubModulesByRoleId,
  uploadCsv,
} from "../../../store";

// React-Select component and styling
import Select from "react-select";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Config file
import { CSVLink } from "react-csv";
import Config from "../../../config/index";

// Cookies
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import EditButton from "components/standardized-components/EditButton";
import UploadButton from "components/standardized-components/UploadButton";
import Cookies from "universal-cookie";

import { Backdrop } from "@mui/material";
import { addMinutes, format } from "date-fns";
const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const ITMATW = ({
  getItemMasterWithPagination,
  itemMasterWithPagination,
  getBinsByItemCode,
  getDynamicColumnReducer,
  editItemMaster,
  uploadCsv,
  getItemsDataForDownload,
  getDownloadItemMasterWithPaginationReducer,
  createItem,
  getDownloadItemMasterWithPagination,
  getItemTypes,
  getItemTypesReducer,
  getSubModulesByRoleIdReducer,
  getSubModulesByRoleId,
  getDynamicColumn,
  createDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  const subModuleId = "a187a7a6-160a-4981-8ff4-004228e19db7";

  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let itemModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "a187a7a6-160a-4981-8ff4-004228e19db7",
  );

  // let createAccess = itemModule
  //   ? itemModule.actionId.includes("bd0ff26b-060e-4ed4-af61-01468c0205d3")
  //   : null;

  // let createAccess =true

  let viewAccess = itemModule
    ? itemModule.actionId.includes("089d64d3-3155-47bb-ba45-f28fd607b21c")
    : null;

  let uploadItem = itemModule
    ? itemModule.actionId.includes("3c048e15-904c-4942-ace7-032b8ab61813")
    : null;

  let editItemAccess = itemModule
    ? itemModule.actionId.includes("48809eb1-80f0-466c-b223-733d4933f17b")
    : null;

  let downloadItem = itemModule
    ? itemModule.actionId.includes("cf7b4a41-91f8-49e0-ac67-778b00e7f887")
    : null;
  let downloadItemTemplate = itemModule
    ? itemModule.actionId.includes("4032f4b8-c898-489b-98fb-4351ea1d22b7")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [itemId, setItemId] = useState("");
  const [binId, setBinId] = useState("");
  const [tableHeading, setTableHeading] = useState("");

  useEffect(() => {
    getItemMasterWithPagination(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject, refresh]);
  useEffect(() => {
    getDownloadItemMasterWithPagination(
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    );
  }, [pageNo, rowsPerPage, searchObject, refresh]);

  const [state, setState] = useState({
    columns: [
      { Header: "Item Code ", accessor: "itemCode" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },

      {
        Header: "Category Description",
        accessor: "categoryDescription",
        align: "left",
      },
      { Header: "Category Code", accessor: "categoryCode", align: "left" },
      { Header: "UOM", accessor: "uom", align: "left" },
      { Header: "Control Type", accessor: "controlTypeValue", align: "left" },
      {
        Header: "Movement Control Type",
        accessor: "movementType",
        align: "left",
      },

      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
              addMinutes(
                new Date(value),
                new Date(value).getTimezoneOffset(),
              ),
              "dd/MM/yyyy hh:mm aaa",
            )
            : "";
        },
      },
      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempItemMaster = [];
    let data = itemMasterWithPagination.itemMaster.data
      ? itemMasterWithPagination.itemMaster.data
      : [];
    setPaginationObj(itemMasterWithPagination?.itemMaster?.pagination);
    setLoading(itemMasterWithPagination.loading);
    data.map((item) => {
      const formatDate = new Date(item.cd);
      let des = item?.itemDescription;
      let len = desLength;
      const itemObject = {
        itemCode: item.itemCode ? `${item.itemCode}` : "",
        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        categoryCode: item.categoryCode,
        categoryDescription: item.categoryName,

        categoryCodeDes: `${item.categoryCode} / ${item.categoryDescription}`,
        uom: item.uom,
        controlTypeValue: item.controlTypeValue,
        controlType:
          (item.controlType === 0 && `No Control`) ||
          (item.controlType === 1 && `Serial Control`) ||
          (item.controlType === 2 && `Lot Control`),
        movementType: item.movementType,
        bin: item.locationName,
        thresholdQty: item.thresholdQty,
        status: item.status,
        // createdDate: item.cd,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: item.cd,
        action: (
          <>
            {editItemAccess && (
              <EditButton
                tooltip="Edit"
                disabled={item.isEditable === 0 ? true : false}
                type="button"
                variant="gradient"
                color="success"
                style={{ borderRadius: "5px" }}
                size="small"
                iconOnly
                onClick={() => {
                  setItemId(item.id);

                  setBinId(item.locationId);
                  handleOpenEditSingleItemMasterModal(item);
                }}
              >
                <Icon>edit</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempItemMaster.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempItemMaster });
  }, [itemMasterWithPagination]);

  const [download, setDownload] = useState("");

  useEffect(() => {
    let tempItemMaster = [];
    let data = getDownloadItemMasterWithPaginationReducer.itemMaster.data
      ? getDownloadItemMasterWithPaginationReducer.itemMaster.data
      : [];
    setPaginationObj(
      getDownloadItemMasterWithPaginationReducer?.itemMaster?.pagination,
    );
    setLoading(getDownloadItemMasterWithPaginationReducer.loading);
    data.map((item) => {
      const formatDate = new Date(item.cd);
      let des = item?.itemDescription;
      let len = desLength;
      const itemObject = {
        itemCode: item.itemCode ? `${item.itemCode}` : "",
        itemDescription: `${des ? des.substring(0, len) : ""}`,
        categoryCode: item.categoryCode,
        categoryDescription: item.categoryName,

        categoryCodeDes: `${item.categoryCode} / ${item.categoryDescription}`,
        uom: item.uom,
        controlTypeValue: item.controlTypeValue,
        controlType:
          (item.controlType === 0 && `No Control`) ||
          (item.controlType === 1 && `Serial Control`) ||
          (item.controlType === 2 && `Lot Control`),
        movementType: item.movementType,
        bin: item.locationName,
        thresholdQty: item.thresholdQty,
        status: item.status,
        cd: item.cd,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),

        action: (
          <>
            {editItemAccess && (
              <EditButton
                tooltip="Edit"
                disabled={item.isEditable === 0 ? true : false}
                type="button"
                variant="gradient"
                color="success"
                style={{ borderRadius: "5px" }}
                size="small"
                iconOnly
                onClick={() => {
                  setItemId(item.id);

                  setBinId(item.locationId);
                  handleOpenEditSingleItemMasterModal(item);
                }}
              >
                <Icon>edit</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempItemMaster.push(itemObject);
    });
    setDownload(tempItemMaster);
  }, [getDownloadItemMasterWithPaginationReducer]);

  const [isSuccessEditThreshold, setIsSuccessEditThreshold] = useState(false);
  const [isErrorEditThreshold, setIsErrorEditThreshold] = useState(false);
  const [isErrorMsgEditThreshold, setIsErrorMsgEditThreshold] = useState("");
  useEffect(() => {
    if (isSuccessEditThreshold) {
      setTimeout(() => {
        setIsSuccessEditThreshold(false);
      }, 3000);
    }
  }, [isSuccessEditThreshold]);
  useEffect(() => {
    if (isErrorEditThreshold) {
      setTimeout(() => {
        setIsErrorEditThreshold(false);
      }, 3000);
    }
  }, [isErrorEditThreshold]);

  const [editItemModal, setEditItemModal] = useState(false);
  const handleEditItemModal = () => {
    setEditItemModal(false);
    formik.setErrors({});
  };
  const handleCloseEditItemModal = () => {
    setEditItemModal(false);
    formik.setErrors({});
  };

  const [singleItemMasterDataForEdit, setSingleItemMasterDataForEdit] =
    useState({});

  const handleOpenEditSingleItemMasterModal = (data = {}) => {
    // formik.setValues(singleItemMasterDataForEdit);

    setMovementTypeSelectedForEdit({
      label: data.movementType,
      value: data.movementType,
    });
    setControlTypeSelectedForEdit({
      label:
        (data.controlType === 0 && "No Control") ||
        (data.controlType === 1 && "Serial Control") ||
        (data.controlType === 2 && "Lot Control"),
      value: data.controlType,
    });
    setSingleItemMasterDataForEdit(data);
    setEditItemModal(true);
  };

  const initialValueForEdit = {
    itemDescription: singleItemMasterDataForEdit.itemDescription
      ? singleItemMasterDataForEdit.itemDescription
      : "",
    controlType: singleItemMasterDataForEdit.controlType
      ? singleItemMasterDataForEdit.controlType
      : "",
    movementType: singleItemMasterDataForEdit.movementType
      ? singleItemMasterDataForEdit.movementType
      : "",
  };

  const validationSchemaForEdit = Yup.object({
    itemDescription: Yup.string().required("Enter the item description"),
    // controlType: Yup.object().required("Enter the control type"),
    // movementType: Yup.object().required("Enter the movement type"),
  });
  const [editButtonName, setEditButtonName] = useState("Submit");

  const onSubmitForEdit = async (values, { resetForm }) => {
    setEditButtonName("Please wait...");
    const payload = {
      id: singleItemMasterDataForEdit.itemId,
      itemCode: singleItemMasterDataForEdit.itemCode,
      itemTypeId: singleItemMasterDataForEdit.itemTypeId,
      uom: singleItemMasterDataForEdit.uom,
      itemDescription: values.itemDescription,
      movementType: movementTypeSelectedForEdit.value,
      controlType: controlTypeSelectedForEdit.value,
    };

    let res = await editItemMaster(payload);

    if (res.status) {
      setIsSuccessEditThreshold(true);
      getItemMasterWithPagination(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
        handleCloseEditItemModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorEditThreshold(true);
      setIsErrorMsgEditThreshold(res.message.data.msg);
      setEditButtonName("Submit");
    }
    // resetForm();
  };

  const formik = useFormik({
    initialValues: initialValueForEdit,
    onSubmit: onSubmitForEdit,
    validationSchema: validationSchemaForEdit,
    enableReinitialize: true,
  });

  const [uomSelected, setUomSelected] = useState("");

  const handleChangeUom = (selectedOption) => {
    setUomSelected(selectedOption);
  };

  const uomOptions = [
    {
      label: "KG",
      value: "KG",
    },
    {
      label: "NOS",
      value: "Nos",
    },
  ];

  const [movementTypeSelected, setMovementTypeSelected] = useState("");

  const handleChangeMovementType = (selectedOption) => {
    setMovementTypeSelected(selectedOption);
  };

  const [movementTypeSelectedForEdit, setMovementTypeSelectedForEdit] =
    useState("");

  const handleChangeMovementTypeForEdit = (selectedOption) => {
    setMovementTypeSelectedForEdit(selectedOption);
  };

  const movementTypeOptions = [
    {
      label: "FIFO",
      value: "FIFO",
    },
    {
      label: "FEFO",
      value: "FEFO",
    },
    {
      label: "No control",
      value: "No control",
    },
  ];

  const [kittingTypeSelected, setKittingTypeSelected] = useState("");

  const handleChangeKittingType = (selectedOption) => {
    setKittingTypeSelected(selectedOption);
  };

  const [kittingTypeSelectedForEdit, setKittingTypeSelectedForEdit] =
    useState("");

  const handleChangeKittingTypeForEdit = (selectedOption) => {
    setKittingTypeSelectedForEdit(selectedOption);
  };

  const kittingTypeOptions = [
    {
      label: "Printing Labels",
      value: 1,
    },
    {
      label: "Mapping Assets",
      value: 2,
    },
    {
      label: "Direct Putaway",
      value: 3,
    },
  ];

  const [controlTypeSelected, setControlTypeSelected] = useState("");

  const handleChangeControlType = (selectedOption) => {
    setControlTypeSelected(selectedOption);
  };

  const [controlTypeSelectedForEdit, setControlTypeSelectedForEdit] =
    useState("");

  const handleChangeControlTypeForEdit = (selectedOption) => {
    setControlTypeSelectedForEdit(selectedOption);
  };

  const controlTypeOptions = [
    {
      label: "No Control",
      value: 0,
    },
    {
      label: "Serial Control",
      value: 1,
    },
    {
      label: "Lot Control",
      value: 2,
    },
  ];

  const [itemTypeSelected, setItemTypeSelected] = useState("");

  const handleChangeItemType = (selectedOption) => {
    setItemTypeSelected(selectedOption);
  };

  const [itemTypeOptions, setItemTypeOptions] = useState([]);

  useEffect(() => {
    let tempItemTypeOptions = [];
    let data = getItemTypesReducer.itemTypes.data
      ? getItemTypesReducer.itemTypes.data
      : [];
    data.map((itemType) => {
      tempItemTypeOptions.push({
        label: itemType.itemType,
        value: itemType.itemTypeId,
      });
    });
    setItemTypeOptions(tempItemTypeOptions);
  }, [getItemTypesReducer]);

  const [openCreateItemModal, setOpenCreateItemModal] = useState(false);

  const handleOpenCreateItemModal = () => {
    getItemTypes(jwtToken);
    setOpenCreateItemModal(true);
    formikForCreateItem.setValues(initialValues);
    formikForCreateItem.setTouched({});
    // formikForCreateItem.setErrors({});
    setItemTypeSelected("");
    setMovementTypeSelected("");
    setControlTypeSelected("");
    setUomSelected("");
  };

  const handleCloseCreateItemModal = () => {
    setOpenCreateItemModal(false);
    // formikForCreateItem.setErrors({});
  };

  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    if (isSuccess) {
      setTimeout(() => {
        setIsSuccess(false);
      }, 3000);
    }
  }, [isSuccess]);
  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setIsError(false);
      }, 3000);
    }
  }, [isError]);

  const initialValues = {
    itemCode: "",
    itemDes: "",
    itemType: "",
    movementType: "",
    controlType: "",
    uom: "",
  };

  const validationSchema = Yup.object({
    itemCode: Yup.string().required("Please enter the item code"),
    itemDes: Yup.string().required("Please enter the item description"),
    itemType: Yup.object().required("Select the Item Type"),
    movementType: Yup.object().required("Select the Movement Type"),
    kittingType: Yup.object().required("Select the Kitting Type"),
    controlType: Yup.object().required("Select the Control Type"),
    uom: Yup.object().required("Select the uom"),
  });

  const [errorMsg, setErrorMsg] = useState("");

  const [buttonName, setButtonName] = useState("Submit");

  const onSubmit = async (values, { resetForm }) => {
    setButtonName("Please wait...");
    const payload = {
      itemCode: values.itemCode.trim(),
      itemDescription: values.itemDes.trim(),
      itemTypeId: itemTypeSelected.value,
      controlType: controlTypeSelected.value,
      uom: uomSelected.value,
      movementType: movementTypeSelected.value,
      kittingType: kittingTypeSelected?.value,
      userId: userId,
    };

    let res = await createItem(payload, jwtToken);
    if (res.status) {
      getItemMasterWithPagination(pageNo, rowsPerPage, searchObject, jwtToken);
      setIsSuccess(true);
      resetForm();
      setItemTypeSelected("");
      setMovementTypeSelected("");
      setControlTypeSelected("");
      setUomSelected("");
      setTimeout(() => {
        setButtonName("Submit");
        handleCloseCreateItemModal();
      }, 2250);
    }
    if (!res.status) {
      setErrorMsg(res.message.data.msg);
      setIsError(true);
      setButtonName("Submit");
    }
  };

  const formikForCreateItem = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
  });

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    let data = new FormData();

    data.append("file", uploadCsvData);

    try {
      let res = await uploadCsv(data, jwtToken);
      if (res?.status === true || res?.data?.status === true) {
        getItemMasterWithPagination(pageNo, rowsPerPage, searchObject, jwtToken);
        setUploadCsvFilter(false);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);

    }
 
  };

  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  const headers = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    { label: "itemDescription", key: "itemDescription" },
    {
      label: "categoryDescription",
      key: "categoryDescription",
    },
    {
      label: "categoryCode",
      key: "categoryCode",
    },
    {
      label: "uom",
      key: "uom",
    },
    {
      label: "controlType",
      key: "controlTypeValue",
    },
    {
      label: "movementType",
      key: "movementType",
    },
    {
      label: "createdDate",
      key: "createdDate",
    },
  ];
  const headersForTemp = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    { label: "itemDescription", key: "itemDescription" },
    {
      label: "itemType",
      key: "itemType",
    },
    {
      label: "controlType",
      key: "controlType",
    },
    {
      label: "movementType",
      key: "movementType",
    },
    {
      label: "uom",
      key: "uom",
    },
    {
      label: "kittingType",
      key: "kittingType",
    },
    {
      label: "categoryCode",
      key: "categoryCode",
    },

  ];

  // const headers = [
  //   {
  //     label: "itemCode",
  //     key: "itemCode",
  //   },
  //   { label: "itemDescription", key: "itemDescription" },
  //   {
  //     label: "itemType",
  //     key: "itemType",
  //   },
  //   {
  //     label: "controlType",
  //     key: "controlType",
  //   },
  //   {
  //     label: "movementType",
  //     key: "movementType",
  //   },
  //   {
  //     label: "kittingType",
  //     key: "kittingType",
  //   },
  //   { label: "uom", key: "uom" },
  // ];

  const csvLink = {
    filename: "Item List.csv",
    headers: headers,
    data: download,
  };

  const csvLink2 = {
    filename: "Item Template.csv",
    headers: headersForTemp,
    data: [],
  };

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getItemMasterWithPagination(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={0} pb={3} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox color="text" p={0} px={2} mt={0} mb={-2}>
                {/* {createAccess && (
                  <CreateButton
                    tooltip="Create Item"
                    // disabled={!createAccess}
                    color="info"
                    variant="contained"
                    type="button"
                    iconOnly
                    onClick={handleOpenCreateItemModal}
                    style={{ marginRight: "1rem", borderRadius: "5px" }}
                    size="small"
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                )} */}

                {downloadItem ? (
                  <CSVLink {...csvLink}>
                    <DownloadDataButton
                      tooltip="Download Items List"
                      style={{ marginRight: "1rem", borderRadius: "8px" }}
                      size="small"
                      type="button"
                      variant="outlined"
                      color="success"
                      iconOnly
                    >
                      <Icon>download</Icon>
                    </DownloadDataButton>
                  </CSVLink>
                ) : (
                  ""
                )}


                {uploadItem && (
                  <UploadButton
                    tooltip="Upload CSV"
                    // disabled={!uploadItem}
                    style={{ marginRight: "1rem", borderRadius: "8px" }}
                    size="small"
                    type="button"
                    variant="outlined"
                    color="info"
                    iconOnly
                    onClick={uploadCsvFilterHandler}
                  >
                    <Icon>upload</Icon>
                  </UploadButton>
                )}

                {downloadItemTemplate ? (
                  <CSVLink {...csvLink2}>
                    <DownloadButton
                      tooltip="Download Template"
                      style={{ marginRight: "1rem", borderRadius: "8px" }}
                      size="small"
                      type="button"
                      variant="outlined"
                      color="error"
                      iconOnly
                    >
                      <Icon>download</Icon>
                    </DownloadButton>
                  </CSVLink>
                ) : (
                  ""
                )}


              </MDBox>
              {uploadCsvFilter && (
                <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                  <div>
                    <input
                      className="choose_file"
                      style={{
                        marginTop: "1.5rem",
                        marginLeft: "1.5rem",
                        // marginBottom: "-9rem",
                      }}
                      type="file"
                      accept=".csv"
                      onChange={(e) => {
                        setUploadCsvData(e.target.files[0]);
                      }}
                    />
                    <MDButton
                      disabled={
                        !uploadCsvData?.name ||
                        uploadCsvData?.type !== "text/csv"
                      }
                      variant="contained"
                      color="info"
                      style={{
                        marginLeft: { xs: "1.5rem", lg: "1" },
                        marginTop: "0rem",
                      }}
                      type="button"
                      onClick={uploadCsvHandler}
                    >
                      UPLOAD
                    </MDButton>
                  </div>
                  <div style={{ marginBottom: "-20px" }}>
                    <span
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginLeft: "30px",
                        fontStyle: "italic",
                      }}
                    >
                      <strong>*</strong> Please upload
                      <strong>".csv"</strong> file only
                    </span>
                  </div>
                </div>
              )}

              <MDBox pt={3} mt={0}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    options={{ draggable: false }}
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openCreateItemModal}
                onClose={handleCloseCreateItemModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Create Item
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseCreateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3} overflow="auto">
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForCreateItem.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Item Code
                        </MDTypography>

                        <MDInput
                          type="text"
                          name="itemCode"
                          className="select-css-for-itemcode"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForCreateItem.handleBlur}
                          onChange={formikForCreateItem.handleChange}
                          value={formikForCreateItem.values.itemCode}
                          error={
                            formikForCreateItem.touched.itemCode &&
                            formikForCreateItem.errors.itemCode &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "10px",
                            },
                            maxLength: 45,
                          }}
                        />
                        {formikForCreateItem.touched.itemCode &&
                          formikForCreateItem.errors.itemCode && (
                            <TextError
                              msg={formikForCreateItem.errors.itemCode}
                            />
                          )}
                      </MDBox>

                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Item Description
                        </MDTypography>

                        <MDInput
                          multiline
                          rows={2}
                          type="text"
                          name="itemDes"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForCreateItem.handleBlur}
                          onChange={formikForCreateItem.handleChange}
                          value={formikForCreateItem.values.itemDes}
                          error={
                            formikForCreateItem.touched.itemDes &&
                            formikForCreateItem.errors.itemDes &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "10px",
                            },
                            maxLength: 45,
                          }}
                        />
                        {formikForCreateItem.touched.itemDes &&
                          formikForCreateItem.errors.itemDes && (
                            <TextError
                              msg={formikForCreateItem.errors.itemDes}
                            />
                          )}
                      </MDBox>

                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Item Type
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="itemType"
                          onBlur={() => {
                            formik.handleBlur({
                              target: { name: "itemType" },
                            });
                          }}
                          value={itemTypeSelected}
                          options={itemTypeOptions}
                          onChange={(selectedOption) => {
                            handleChangeItemType(selectedOption);
                            formikForCreateItem.setFieldValue(
                              "itemType",
                              selectedOption,
                            );
                          }}
                        />
                        {formikForCreateItem.touched.itemType &&
                          formikForCreateItem.errors.itemType && (
                            <TextError
                              msg={formikForCreateItem.errors.itemType}
                            />
                          )}
                      </MDBox>

                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Control Type
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="controlType"
                          value={controlTypeSelected}
                          options={controlTypeOptions}
                          onBlur={formikForCreateItem.handleBlur}
                          onChange={(selectedOption) => {
                            handleChangeControlType(selectedOption);
                            formikForCreateItem.setFieldValue(
                              "controlType",
                              selectedOption,
                            );
                          }}
                        />
                        {formikForCreateItem.touched.itemType &&
                          formikForCreateItem.errors.controlType && (
                            <TextError
                              msg={formikForCreateItem.errors.controlType}
                            />
                          )}
                      </MDBox>

                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Movement Control type
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="movementType"
                          value={movementTypeSelected}
                          options={movementTypeOptions}
                          onBlur={formikForCreateItem.handleBlur}
                          onChange={(selectedOption) => {
                            handleChangeMovementType(selectedOption);
                            formikForCreateItem.setFieldValue(
                              "movementType",
                              selectedOption,
                            );
                          }}
                        />
                        {formikForCreateItem.touched.itemType &&
                          formikForCreateItem.errors.movementType && (
                            <TextError
                              msg={formikForCreateItem.errors.movementType}
                            />
                          )}
                      </MDBox>
                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Kitting Type
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="kittingType"
                          onBlur={() => {
                            formik.handleBlur({
                              target: { name: "kittingType" },
                            });
                          }}
                          value={kittingTypeSelected}
                          options={kittingTypeOptions}
                          onChange={(selectedOption) => {
                            handleChangeKittingType(selectedOption);
                            formikForCreateItem.setFieldValue(
                              "kittingType",
                              selectedOption,
                            );
                          }}
                        />
                        {formikForCreateItem.touched.kittingType &&
                          formikForCreateItem.errors.kittingType && (
                            <TextError
                              msg={formikForCreateItem.errors.kittingType}
                            />
                          )}
                      </MDBox>

                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          UOM
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="uom"
                          onBlur={formikForCreateItem.handleBlur}
                          value={uomSelected}
                          options={uomOptions}
                          onChange={(selectedOption) => {
                            handleChangeUom(selectedOption);
                            formikForCreateItem.setFieldValue(
                              "uom",
                              selectedOption,
                            );
                          }}
                        />
                        {formikForCreateItem.touched.uom &&
                          formikForCreateItem.errors.uom && (
                            <TextError msg={formikForCreateItem.errors.uom} />
                          )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccess}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccess(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Item Created successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={
                            !formikForCreateItem.isValid ||
                            buttonName === "Please wait..."
                          }
                        >
                          {buttonName}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={editItemModal}
                onClose={handleCloseEditItemModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForEdit}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Update
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseEditItemModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            // marginLeft: "-55px",
                            // marginBottom: "5px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Item Description
                        </MDTypography>

                        <MDInput
                          multiline
                          rows={2}
                          type="text"
                          name="itemDescription"
                          fullWidth
                          autoComplete="off"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.itemDescription}
                          error={
                            formik.touched.itemDescription &&
                            formik.errors.itemDescription &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "10px",
                            },
                          }}
                        />
                        {formik.touched.itemDescription &&
                          formik.errors.itemDescription && (
                            <TextError msg={formik.errors.itemDescription} />
                          )}
                      </MDBox>
                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Control Type
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="controlType"
                          value={controlTypeSelectedForEdit}
                          options={controlTypeOptions}
                          onChange={(selectedOption) => {
                            handleChangeControlTypeForEdit(selectedOption);
                            formik.setFieldValue("controlType", selectedOption);
                          }}
                        />
                        {formik.errors.controlType && (
                          <TextError msg={formik.errors.controlType} />
                        )}
                      </MDBox>

                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Movement Type
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="movementType"
                          value={movementTypeSelectedForEdit}
                          options={movementTypeOptions}
                          onChange={(selectedOption) => {
                            handleChangeMovementTypeForEdit(selectedOption);
                            formik.setFieldValue(
                              "movementType",
                              selectedOption,
                            );
                          }}
                        />
                        {formik.errors.movementType && (
                          <TextError msg={formik.errors.movementType} />
                        )}
                      </MDBox>
                      <MDBox>
                        <Collapse in={isErrorEditThreshold}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorEditThreshold(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {isErrorMsgEditThreshold}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessEditThreshold}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessEditThreshold(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Updated successfully!
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={2}>
                        <MDButton
                          fullWidth
                          variant="gradient"
                          color="success"
                          type="submit"
                          disabled={
                            !formik.isValid ||
                            !movementTypeSelectedForEdit ||
                            !controlTypeSelectedForEdit ||
                            editButtonName === "Please wait..."
                          }
                        >
                          {editButtonName}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    itemMasterWithPagination: state.itemMasterWithPagination,
    getItemTypesReducer: state.getItemTypesReducer,
    binsByItemCode: state.binsByItemCode,
    getItemsDataForDownloadReducer: state.getItemsDataForDownloadReducer,

    getDownloadItemMasterWithPaginationReducer:
      state.getDownloadItemMasterWithPaginationReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getItemMasterWithPagination: (
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getItemMasterWithPagination(
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    getDownloadItemMasterWithPagination: (
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getDownloadItemMasterWithPagination(
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    getItemTypes: (jwtToken) => dispatch(getItemTypes(jwtToken)),
    editItemMaster: (payload, jwtToken) =>
      dispatch(editItemMaster(payload, jwtToken)),

    uploadCsv: (payload, jwtToken) => dispatch(uploadCsv(payload, jwtToken)),

    createItem: (payload, jwtToken) => dispatch(createItem(payload, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ITMATW);
